import { useEffect } from "react"
import { Outlet } from "react-router-dom"

import useServices from "@/hooks/useServices"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./SsoPopupTemplate.module.scss"

// A Kodem SSO popup is a small window that closes itself: no logo, chat launcher, region, card or footer
export const SsoPopupTemplate = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "auth.ssoPopupSigningIn"
  })
  const { intercom } = useServices()

  useEffect(() => {
    intercom.hideLauncher()

    const prevTitle = document.title
    document.title = t("pageTitle")

    return () => {
      document.title = prevTitle
    }
  }, [t, intercom])

  return (
    <div data-testid="ssoPopupTemplate" className={styles.container}>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  )
}
